import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-charcoal-200 py-12 text-center text-sm" data-id="element-51">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4" data-id="element-52">
        <p className="font-serif text-lg text-cream" data-id="element-53">
          SOS Alergias: El Fin del Rascado
        </p>
        <p data-id="element-54">© {new Date().getFullYear()} Todos los derechos reservados.</p>
        <p className="text-charcoal-400 max-w-2xl mx-auto text-xs leading-relaxed" data-id="element-55">
          Descargo de responsabilidad: La información proporcionada en esta guía
          tiene fines educativos y no sustituye el consejo, diagnóstico o
          tratamiento veterinario profesional. Siempre consulta a tu veterinario
          antes de realizar cambios significativos en la dieta o rutina de salud
          de tu mascota.
        </p>
      </div>
    </footer>;
}